import { Stack } from "@mui/material";
import type { FC } from "react";
import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DataRow } from "web_myplann/Shared/Components/DataRow";
import { dateFormatter } from "web_myplann/Shared/Utils/formatters";

type Props = {
	data: PortfolioDetailResponseDTO;
};

export const BasicInfo: FC<Props> = ({ data }) => {
	const { t } = useResource();

	if (data.signedAt || data.startAt || data.endAt) {
		return (
			<Stack>
				<DataRow
					label={t(Resources.PortfolioDetail.SharedLabels.signDate)}
					value={dateFormatter(data.signedAt)}
				/>
				<DataRow
					label={t(Resources.PortfolioDetail.SharedLabels.beginDate)}
					value={dateFormatter(data.startAt)}
				/>
				<DataRow
					label={t(Resources.PortfolioDetail.SharedLabels.endDate)}
					value={dateFormatter(data.endAt)}
				/>
			</Stack>
		);
	}

	return null;
};
